import { render, staticRenderFns } from "./layout-admin.vue?vue&type=template&id=629b8a04&lang=pug&"
import script from "./layout-admin.vue?vue&type=script&lang=js&"
export * from "./layout-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports